import { createAction, createSelector } from '@reduxjs/toolkit';
import { BaseEntityStoreBuilder } from 'app/store/helpers';
import universalLinkService from './universalLinkService';

export const UNIVERSAL_LINKS_KEY = 'universalLinks';

const storeBuilder = new BaseEntityStoreBuilder(UNIVERSAL_LINKS_KEY, universalLinkService);

const entityStore = (state) => state[UNIVERSAL_LINKS_KEY];

export const actions = {
  getAllUniversalLinks: storeBuilder.actions.getAll,
  createUniversalLink: storeBuilder.actions.create,
  updateUniversalLink: storeBuilder.actions.update,
  deleteUniversalLink: storeBuilder.actions.delete,
  clearErrors: createAction(`${UNIVERSAL_LINKS_KEY}/clearErrors`),
};

export const selectors = {
  ...storeBuilder.selectors,
  selectLoading: createSelector(entityStore, (state) => state.loading),
  selectError: createSelector(entityStore, (state) => state.error),
};

const universalLinkSlice = storeBuilder.generateSlice((builder) =>
  builder.addCase(actions.clearErrors, (state) => {
    state.error = null;
    state.success = null;
  })
);

export default universalLinkSlice.reducer;
